import React from 'react';
import styled from 'styled-components';

import { Container, Row, Col } from './Grid';

const FeedbackContainer = styled(Container)`
  margin-bottom: 1em;
  margin-top: 1em;
`;
const Header = styled.div`
  font-weight: bold;
  text-transform: uppercase;
`;
const Result = styled.span`
  color: ${props => props.passed ? 'green' : 'red'};
`;
const FeedbackText = styled.p`
  margin-bottom: 0;
`;

const Loading = styled.div`
  margin-top: 1em;
  height: ${1.125 * 2}em;
`;
const LoadingContainer = (props) => {
  if (props.loading) {
    return <Loading>Loading</Loading>;
  } else {
    return (
      <div>
        {props.children}
      </div>
    );
  }
}

const Feedback = (props) => {
  return (
    <FeedbackContainer>
      <Row>
        <Col>
          <LoadingContainer loading={props.loading}>
            <Header>
              Result:
              {' '}
              {typeof props.passed === 'boolean' &&
                <Result passed={props.passed}>
                  {props.passed ? 'Passed' : 'Failed'}
                </Result>
              }
            </Header>
            <FeedbackText>
              {props.feedbackText || 'As you type feedback will appear here'}
            </FeedbackText>
          </LoadingContainer>
        </Col>
      </Row>
    </FeedbackContainer>
  );
};
Feedback.propTypes = {
  feedbackText: React.PropTypes.string,
  passed: React.PropTypes.bool,
  loading: React.PropTypes.bool.isRequired,
};

export default Feedback;



// WEBPACK FOOTER //
// ./src/Feedback.js